//子级router-view承载
import Center from '@/components/common/center'

//客户管理
import Customer from '@/pages/client_mgr/list'
// 账号管理 修改密码
import Changepassword from '@/pages/client_mgr/changepassword'
//个人资料
import Userinfo from '@/pages/client_mgr/userinfo.vue'

export default [{
    path: '/Customer',
    component: Customer,
    meta: {
      title: '客户管理'
    },
  },
  {
    path: '/Authority',
    component: Center,
    redirect: '/Authority/Account',
    meta: {
      title: "权限管理"
    },
    children: [
      {
        path: '/Authority/Changepassword',
        component: Changepassword,
        meta: {
          title: "修改密码"
        },

      },
      {
        path: '/Authority/Userinfo',
        component: Userinfo,
        meta: {
          title: "个人资料"
        },
      },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/module/client_mgr.js